import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { User } from '../models/user';

@Injectable({
    providedIn: 'root',
})
export class UsersService {
    constructor(private http: HttpClient) {}
    getAllUsers(
        pageSize: number,
        pageNumber: number,
        searchTerm: string,
        userType: string,
        fromDate?: string,
        toDate?: string
    ): Observable<{
        data: Array<User>;
    }> {
        const params = new HttpParams()
            .set('searchTerm', searchTerm)
            .set('pageSize', pageSize)
            .set('pageNumber', pageNumber)
            .set('userType', userType)
            .set('fromDate', fromDate || null)
            .set('toDate', toDate || null);

        return this.http.get<{
            data: Array<User>;
        }>(`${environment.api_url}/users/search`, { params });
    }

    getUser(id: string): Observable<{
        data: User & { userId: string; documents: Array<{ [key: string]: any }> };
    }> {
        return this.http.get<{
            data: User & { userId: string; documents: Array<{ [key: string]: any }> };
        }>(`${environment.api_url}/users/${id}`);
    }

    updateUserStatus(
        userId: string,
        status: {
            value: string;
            date: Date;
            name: string;
            _id: string;
            notes: string | null;
        }
    ): Observable<any> {
        return this.http.patch(`${environment.api_url}/users/${userId}/status`, status);
    }
}
